import { TBaseAnswerFlow, TDependsOnAnswer, TDirectAnswer } from "./beauty/types";
import { getProjectTitle } from "./surveyUtil";
import { TSurveyFeature } from "./types";

export function randInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function randChoice<T>(items: T[]): T {
  if (items.length === 0) {
    throw new Error("Input array must not be empty");
  }

  const index = Math.floor(Math.random() * items.length);
  return items[index];
}

export function scrollToElementWithOffset(el: HTMLElement, offsetPx = 40) {
  const rect = el.getBoundingClientRect();
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const targetY = rect.top + scrollTop - offsetPx;

  window.scrollTo({
    top: targetY,
    behavior: "smooth",
  });
}

export function filterFeaturesBasedOncurrentProject(surveyFeatures: TSurveyFeature[]) {
  const resultFeatures: TSurveyFeature[] = [];

  const currentProject = getProjectTitle();
  for (const feature of surveyFeatures) {
    if (!feature.regex.test(currentProject)) {
      console.warn(
        `Feature '${feature.featureName}' not loaded: Required Project regex`,
        feature.regex,
        `not matched. Current project title '${currentProject}'`
      );
      continue;
    }

    resultFeatures.push(feature);
  }

  return resultFeatures;
}

export async function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getSlug(input: string): string {
  return input
    .toLowerCase()
    .normalize("NFD") // Normalize accents
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
    .replace(/[^a-z0-9\s-]/g, "") // Remove non-alphanumeric characters
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-") // Collapse multiple hyphens
    .replace(/^-|-$/g, ""); // Trim hyphens from start/end
}

export function setDirectAnswerPreset(
  sectionName: TBaseAnswerFlow["sectionName"],
  questionLabel: TBaseAnswerFlow["questionLabel"],
  questionType: TBaseAnswerFlow["questionType"],
  answer: TDirectAnswer["answer"]
): TBaseAnswerFlow & TDirectAnswer {
  return {
    sectionName,
    questionLabel,
    questionType,
    answerDependency: "directAnswer",
    answer,
  };
}

export function setDependentAnswerPreset(
  sectionName: TBaseAnswerFlow["sectionName"],
  questionLabel: TBaseAnswerFlow["questionLabel"],
  questionType: TBaseAnswerFlow["questionType"],
  keys: TDependsOnAnswer["dependsOn"]["keys"],
  getAnswer: TDependsOnAnswer["dependsOn"]["getAnswer"]
): TBaseAnswerFlow & TDependsOnAnswer {
  return {
    sectionName,
    questionLabel,
    questionType,
    answerDependency: "dependsOn",
    dependsOn: {
      keys,
      getAnswer,
    },
  };
}
